module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_8019.337d1d10.png";